import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';
import { PaymentService } from '../../services/payment.service';
import { IResponse } from '../../interfaces/response';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  styleUrls: ['./upgrade-plan.component.scss']
})
export class UpgradePlanComponent implements OnInit {
  @Input() data: any;
  memberId: any;
  constructor(public modalRef: BsModalRef, public toastr: ToastrService,public commonService: CommonService, public paymentService: PaymentService) { }

  ngOnInit(): void {
    if (this.modalRef.content.memberId) {
      this.memberId = this.modalRef.content.memberId;
      // Now you can use this.memberId in your modal functions
    }
  }

  confirmUpgrade(){
    this.paymentService.upgradPlan(this.memberId).subscribe((res: IResponse) => {
      if (res && !res.errors) {
        localStorage.setItem('planType','2');
        const userData = localStorage.getItem('userData');
        const updatePlanMemberData = JSON.parse(userData);
        updatePlanMemberData.user.plan_type = 2;
        this.commonService.userData.next(updatePlanMemberData);
        localStorage.setItem('userData', JSON.stringify(updatePlanMemberData));
        this.modalRef.hide();
        this.toastr.success(res.message);
        window.location.reload();
      }
    });
  }
}
